module.exports = __webpack_public_path__ + "img/1670079897285.95d16466.jpeg";